"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _MediaTypes = require("../../constants/MediaTypes");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _UploadSource = require("./UploadSource.styled");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _utils = require("./utils/utils");
var _UploadZone = _interopRequireDefault(require("./UploadZone"));
var _UploadSourceFooter = _interopRequireDefault(require("./UploadSourceFooter"));
var _file = require("../../utils/file/file");
var _utilHelpers = require("../../utils/utilHelpers/utilHelpers");
var _sourceFileHelper = require("../../utils/sourceFileHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var logger = new _StudioLogger.StudioLogger('Media Upload');
var UploadSource = function UploadSource(_ref) {
  var onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];

  /**
   * Callback that is fired during drag-n-drop and manual file upload
   * @param {*} uploadedFiles - Files that were uploaded
   * @param {*} isDragAndDrop - Boolean representing if the files were uploaded by drag and drop
   */
  var onFileChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uploadedFiles, isDragAndDrop) {
      var uploadedFilesArray, currentFilesInState, fileIndex;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            uploadedFilesArray = Array.from(uploadedFiles);
            currentFilesInState = files.length;
            for (fileIndex = 0; fileIndex < uploadedFilesArray.length; fileIndex++) {
              uploadedFilesArray[fileIndex].errors = (0, _utils.validateSourceFile)(uploadedFilesArray[fileIndex], ++currentFilesInState);
              uploadedFilesArray[fileIndex].isDragAndDrop = isDragAndDrop;
              uploadedFilesArray[fileIndex].isMultiFileUpload = true;
            }
            setFiles(function (previousState) {
              return (0, _utils.mergeAndRemoveDuplicates)(uploadedFilesArray, previousState);
            });

            // Datadog logging for each newly added file
            if (uploadedFilesArray.length <= _MediaTypes.SOURCE_MAX_UPLOAD_COUNT) {
              uploadedFilesArray.forEach(function (file) {
                if (Array.isArray(file.errors) && file.errors.length === 0) {
                  logger.info(_MediaTypes.MEDIA_UPLOAD_ACTION, {
                    fileName: file.name,
                    fileType: (0, _sourceFileHelper.getFileExtension)(file.name)
                  });
                } else {
                  logger.error(_MediaTypes.MEDIA_UPLOAD_ACTION, {
                    fileName: file.name,
                    fileType: (0, _sourceFileHelper.getFileExtension)(file.name),
                    errors: file.errors
                  });
                }
              });
            } else {
              logger.error(_MediaTypes.MEDIA_UPLOAD_ACTION, {
                error: "Exceeds maximum number of uploads (limit is 5), total uploaded files ".concat(uploadedFilesArray.length)
              });
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onFileChange(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var sources = files.map(function (file) {
    var source = {
      ext: (0, _sourceFileHelper.getFileExtension)(file.name),
      title: file.name,
      value: file,
      isDragAndDrop: file.isDragAndDrop,
      isMultiFileUpload: file.isMultiFileUpload,
      fileSize: file.size
    };
    return source;
  });
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    // If only one file is being uploaded, then isMultiFileUpload should be 'false'
    if ((sources === null || sources === void 0 ? void 0 : sources.length) === 1) {
      sources[0].isMultiFileUpload = false;
    }
    onSubmit(sources);
  };
  var removeFile = function removeFile(index) {
    setFiles(function (previousState) {
      var removedFile = previousState[index];
      var filesInState = (0, _toConsumableArray2["default"])(previousState);
      filesInState.splice(index, 1);
      var fileCount = 0;
      filesInState.forEach(function (file) {
        fileCount++;
        if ((0, _utils.fileHasMaxFileCountError)(file === null || file === void 0 ? void 0 : file.errors) && fileCount <= _MediaTypes.SOURCE_MAX_UPLOAD_COUNT) {
          file.errors = file.errors.filter(function (error) {
            return !error.includes('Exceeds maximum number of');
          });
        }
        //don't need to run it if max limit is exceed
        if (fileCount > _MediaTypes.SOURCE_MAX_UPLOAD_COUNT) {
          return;
        }
      });

      // Datadog logging for file removal with file details and errors
      if (removedFile.errors && removedFile.errors.length > 0) {
        logger.error(_MediaTypes.MEDIA_REMOVAL_ACTION, {
          fileName: removedFile.name,
          fileType: (0, _sourceFileHelper.getFileExtension)(removedFile.name),
          errors: removedFile.errors
        });
      } else {
        logger.info(_MediaTypes.MEDIA_REMOVAL_ACTION, {
          fileName: removedFile.name,
          fileType: (0, _sourceFileHelper.getFileExtension)(removedFile.name)
        });
      }
      return filesInState;
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_UploadSource.SourceFormContainer, null, /*#__PURE__*/_react["default"].createElement(_UploadSource.UploadContentHeading, null, "Upload content"), /*#__PURE__*/_react["default"].createElement(_reactstrap.Form, {
    "data-test": "sourceCreateForm",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(_UploadZone["default"], {
    disabled: isSubmitting,
    onFileChange: onFileChange
  }), /*#__PURE__*/_react["default"].createElement(_UploadSource.UploadedFiles, null, files === null || files === void 0 ? void 0 : files.map(function (file, index) {
    var _file$errors;
    return /*#__PURE__*/_react["default"].createElement(_UploadSource.StyledFileContainer, {
      key: index,
      className: (0, _utils.hasError)(file === null || file === void 0 ? void 0 : file.errors) && 'text-secondary',
      "data-testid": "uploadedFile"
    }, /*#__PURE__*/_react["default"].createElement(_UploadSource.StyledFile, null, /*#__PURE__*/_react["default"].createElement(_UploadSource.StyledFileName, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faFileVideo,
      color: "grey"
    }), " ".concat((0, _utilHelpers.truncate)(file.name, 50), " (").concat((0, _file.formatBytes)(file.size), ")")), file === null || file === void 0 || (_file$errors = file.errors) === null || _file$errors === void 0 ? void 0 : _file$errors.map(function (error, index) {
      return /*#__PURE__*/_react["default"].createElement(_UploadSource.FileErrors, {
        key: index
      }, error);
    })), /*#__PURE__*/_react["default"].createElement("div", null, (0, _utils.hasError)(file === null || file === void 0 ? void 0 : file.errors) ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faTimesCircle,
      className: "text-danger",
      role: "button",
      "data-testid": "removeFile",
      onClick: function onClick() {
        return removeFile(index);
      }
    }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeRegularSvgIcons.faTimesCircle,
      role: "button",
      "data-testid": "removeFile",
      onClick: function onClick() {
        return removeFile(index);
      }
    })));
  })), /*#__PURE__*/_react["default"].createElement(_UploadSourceFooter["default"], {
    createButtonText: (0, _utils.getButtonText)(isSubmitting),
    onCancel: onCancel,
    disabled: (0, _utils.isDisabled)(files)
  })));
};
UploadSource.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = UploadSource;